import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from 'app/crud/crud.service';
import { result } from 'lodash';


@Component({
  selector: 'app-horario-layout-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit {
  dato: FormGroup;
  tamano = document.body.clientHeight;
  tieneid: any;
  constructor(private fb: FormBuilder, private route: ActivatedRoute, private crud: CrudService,) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [""],
      nombre: [""],
      predeterminado: [0],
      turnos_id: ["", [Validators.required]],
      modalidades_id: ["", [Validators.required]],
      duracion_clase: ["", [Validators.required]],
      hora_inicio: ["", [Validators.required]]
    });

    // this.route.params.subscribe(params => {
    //   this.tieneid = params['id'];
      
    //   //   // ? modificado por que no carga catalogos
    //   // if (!localStorage.getItem('refresh')) { 
    //   //   localStorage.setItem('refresh', 'no refresh') 
    //   //   location.reload() 
    //   // } else {
    //   //   localStorage.removeItem('refresh') 
    //   // }
    // });

    //this.cargarDatos();


    this.cargarModalidades();

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById('catalogos').click();
    //document.getElementById('enviarModalidades').click();

    //  if (!localStorage.getItem('refresh')) { 
    //     localStorage.setItem('refresh', 'no refresh') 
    //     location.reload() 
    //   } else {
    //     localStorage.removeItem('refresh') 
    //   }
  }

  parametros = {
    pagina: 0,
    limite: 0
  };

  modalidades:any = []
  
cargarModalidades(){

  this.crud.lista(this.parametros,'modalidad').subscribe(resultado =>{
    console.log(resultado);
    this.modalidades = resultado.data
  })

}
//   cargarDatos() {
//     this.crud.ver(this.tieneid, "horario-layout").subscribe(resultado => {
//       console.log(resultado.data.turnos_id);
//       this.dato = this.fb.group({
//         id: [this.tieneid],
//         nombre: [resultado.data.nombre, [Validators.required]],
//         predeterminado: [resultado.data.predeterminado],
//         turnos_id: [resultado.data.turnos_id, [Validators.required]],
//         modalidades_id: [resultado.data.modalidades_id, [Validators.required]],
//         duracion_clase: [resultado.data.duracion_clase, [Validators.required]],
//         hora_inicio: [resultado.data.hora_inicio, [Validators.required]]
//       })
//     })
//   }
}
